import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthProvider';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useContext(AuthContext);

    useEffect(() => {
        if (!loading && !isAuthenticated) {
            // Open login modal instead of redirecting
            document.dispatchEvent(new CustomEvent('open-login-modal'));
        }
    }, [loading, isAuthenticated]);

    if (loading) {
        return <div className="flex justify-center items-center min-h-screen">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-accent"></div>
        </div>;
    }

    if (!isAuthenticated) {
        // Return to home page and the modal will be shown due to the event
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute; 